module.exports = "/_next/static/images/HeroVideoCoverImage-83845a9bacc5262f09a9a9981f884595.png";